import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

// Services
import { TranslationService } from '../translation/translation.service';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly translate = inject(TranslationService);
  private readonly alertController = inject(AlertController);

  async showAlert(header: string, message: string, _buttons?: 'ok' | 'ok|cancel'): Promise<HTMLIonAlertElement> {
    const buttons = [{ role: 'confirm', text: 'OK' }];

    if (_buttons?.includes('cancel')) {
      buttons.push({ role: 'cancel', text: this.translate.instant('COMMON.CANCEL') });
    }

    const alert = await this.alertController.create({
      header,
      message,
      backdropDismiss: false,
      buttons,
      cssClass: 'confirm-cancel-alert',
    });
    await alert.present();

    return alert;
  }

  async showAlertBuyActivationCode(buttonText: string): Promise<HTMLIonAlertElement> {
    const buttons = [
      { role: 'cancel', text: this.translate.instant('COMMON.CANCEL') },
      { role: 'confirm', text: this.translate.instant(buttonText) },
    ];
    const header = this.translate.instant('COMMON.CAUTION');
    const message = this.translate.instant('COMMON.TRIAL_EXPIRED');

    const alert = await this.alertController.create({
      header,
      message,
      buttons,
      backdropDismiss: false,
      cssClass: 'confirm-cancel-alert',
    });
    await alert.present();

    return alert;
  }

  async showTrialAlert(): Promise<HTMLIonAlertElement> {
    const alert = await this.alertController.create({
      header: this.translate.instant('HOME.TRY'),
      message: this.translate.instant('HOME.TRIAL_EMAIL'),
      cssClass: 'confirm-cancel-alert',
      inputs: [
        {
          type: 'email',
          placeholder: 'Email',
          label: 'Email',
          name: 'email',
          id: 'trial-alert__input-email',
        },
      ],
      buttons: [
        {
          role: 'cancel',
          text: this.translate.instant('COMMON.CANCEL'),
          cssClass: 'garnet-dark',
        },
        {
          role: 'confirm',
          text: 'OK',
          id: 'trial-alert__confirm-button',
        },
      ],
    });

    const input: HTMLInputElement = document.querySelector('#trial-alert__input-email');
    const confirmButton: HTMLButtonElement = document.querySelector('#trial-alert__confirm-button');
    input.onkeyup = () => {
      // eslint-disable-next-line no-useless-escape
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      confirmButton.disabled = !regex.test(input.value);
    };
    input.onkeyup(null);

    await alert.present();
    return alert;
  }

  async showAlertBlockApplication(): Promise<HTMLIonAlertElement> {
    const alert = await this.alertController.create({
      header: this.translate.instant('COMMON.CAUTION'),
      message: this.translate.instant('COMMON.CONNECT_TO_INTERNET'),
      backdropDismiss: false,
    });
    await alert.present();
    return alert;
  }
}
